import { ContainerUI } from './PortalUnavailable.css'
import Heading from 'hsds/components/heading'
import Text from 'hsds/components/text'

const PortalUnavailable = () => (
  <ContainerUI>
    <Heading selector="h1" size="h3">
      This portal isn&apos;t available right now
    </Heading>
    <Text selector="p" muted size={14}>
      Please try again later.
    </Text>
  </ContainerUI>
)

export default PortalUnavailable
